// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__QDCSJ","alertIcon":"ConfirmModal_alertIcon__12lWu"};